import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import "./SignIn.css";

/* ================= API BASE ================= */
const normalizeBase = (value) =>
  String(value || "").trim().replace(/\/+$/, "");

const ensureApiSuffix = (base) => {
  const clean = normalizeBase(base);

  if (!clean) return "http://localhost:5000/api";

  return clean.endsWith("/api") ? clean : `${clean}/api`;
};

const API_BASE = ensureApiSuffix(
  process.env.REACT_APP_API_BASE || "http://localhost:5000"
);

/* ================= VALIDATION ================= */
const isValidEmail = (email = "") =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

/* ================= COMPONENT ================= */
function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const safeSuccessMessage =
    "If this email is registered, you will receive a password reset link shortly.";

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setMessage("");

    const normalizedEmail = email.trim().toLowerCase();

    if (!normalizedEmail) {
      setError("Email address is required.");
      return;
    }

    if (!isValidEmail(normalizedEmail)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);

      await fetch(`${API_BASE}/auth/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: normalizedEmail,
        }),
      });

      setMessage(safeSuccessMessage);
      setEmail("");
    } catch {
      setMessage(safeSuccessMessage);
      setEmail("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      <section className="signin-section">
        <div className="signin-container">
          <div className="signin-left">
            <h1>Reset Your Password 🔐</h1>

            <p>
              Enter your registered email address. We will send a secure reset
              link if the account exists.
            </p>

            <div className="signin-features">
              <div>✔ Secure token</div>
              <div>✔ 15-minute expiry</div>
              <div>✔ Email recovery</div>
            </div>
          </div>

          <div className="signin-card">
            <h2>Forgot Password</h2>

            {error ? <div className="auth-alert auth-error">{error}</div> : null}
            {message ? (
              <div className="auth-alert auth-success">{message}</div>
            ) : null}

            <form onSubmit={handleSubmit} className="signin-form">
              <div className="signin-input-group">
                <label htmlFor="forgot-email">Email Address</label>

                <input
                  id="forgot-email"
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={handleEmailChange}
                  required
                  disabled={loading}
                  autoComplete="email"
                />
              </div>

              <button type="submit" className="signin-btn" disabled={loading}>
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>

            <div className="signin-extra">
              <span>Remember your password?</span>
              <Link to="/signin">Back to Sign In</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ForgotPassword;